import { HrGroupBy } from "models/hr-dashboard";

interface GroupToggleProps {
    value: HrGroupBy;
    onChange: (value: HrGroupBy) => void;
}

const OPTIONS: { value: HrGroupBy; label: string }[] = [
    { value: "department", label: "Department" },
    { value: "division", label: "Division" },
];

const GroupToggle = ({ value, onChange }: GroupToggleProps) => (
    <div className="btn-group btn-group-sm mb-3" role="group" aria-label="Group by">
        {OPTIONS.map(o => (
            <button
                key={o.value}
                type="button"
                className={`btn ${value === o.value ? "btn-primary" : "btn-outline-primary"}`}
                onClick={() => onChange(o.value)}
            >
                {o.label}
            </button>
        ))}
    </div>
);

export default GroupToggle;
